export default __webpack_public_path__ + "static/media/element_spec_45.2b171f5e.jpg";